/* unplugin-vue-components disabled */import { render } from "./InviteHome.vue?vue&type=template&id=28c675ab&scoped=true"
import script from "./InviteHome.vue?vue&type=script&lang=js"
export * from "./InviteHome.vue?vue&type=script&lang=js"

import "./InviteHome.vue?vue&type=style&index=0&id=28c675ab&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c675ab"]])

export default __exports__